import { render, staticRenderFns } from "./ContactNoteByMonthAndUser.vue?vue&type=template&id=0c22b745&scoped=true&"
import script from "./ContactNoteByMonthAndUser.vue?vue&type=script&lang=js&"
export * from "./ContactNoteByMonthAndUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/jenkins_node_modules/doris/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c22b745",
  null
  
)

export default component.exports